import actionTypes from '../../actions/dictionaries/dictionaries.action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_CLASS_DICTIONARY_SUCCESS:
      return { ...action.userClass };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionaries/user-class-dictionary.js